import Head from "next/head";

import config from "config";

import NewProjectLayout from "modules/projects/elements/New-Project-Entitlement-Wrapper";
import CreateProject from "flows/sales-effectiveness/views/create-project";

const Page = () => {
  return (
    <>
      <Head>
        <title>
          {config.SITE_NAME} | Create New Sales Effectiveness Project
        </title>
      </Head>
      <CreateProject />
    </>
  );
};

Page.getLayout = (page) => <NewProjectLayout>{page}</NewProjectLayout>;

export default Page;
